import { render, staticRenderFns } from "./CatalogSearch.vue?vue&type=template&id=6c794463"
import script from "./CatalogSearch.vue?vue&type=script&lang=js"
export * from "./CatalogSearch.vue?vue&type=script&lang=js"
import style0 from "./CatalogSearch.vue?vue&type=style&index=0&id=6c794463&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports